import React, { Component } from 'react';
import { fetchData, getCartProducts, getProducts, get_user_lang } from '../../../repository';

let iPad = 768; 
let iPadpro = 1024;
let popoverWidth = '';
let BASE_URL = '';
let ASSETS_URL = '';
let cart_url;
let checkout_url;
let basketItems; 
let basket_filled;

if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    BASE_URL = 'http://localhost:8001';
    ASSETS_URL = ""
}else if (window.location.hostname === 'dev.cocoonsealy.net'){
    BASE_URL = 'http://dev.cocoonsealy.net';
    ASSETS_URL = "http://dev.cocoonsealy.net"
}else if (window.location.hostname === 'staging.cocoonbysealy.ca'){
    BASE_URL = 'https://staging.cocoonbysealy.ca';
    ASSETS_URL = "https://staging.cocoonbysealy.ca"
}else{
    BASE_URL = 'https://cocoonbysealy.ca';
    ASSETS_URL = "https://assets-www.cocoonbysealy.ca"
}


class Cartbasketitems extends Component {    
    
    constructor(props) {
        super(props);
        this.state = {            
            minibasket_set: false,
            basketItems: ''
        };                
    }

    componentDidMount() {
        // console.log('Basket Items')    
        cart_url = document.getElementsByClassName('basket-summary')[0].getAttribute('href');
        checkout_url = document.getElementsByClassName('checkout-index')[0].getAttribute('href');           
        this.query_products();      
    }    

    componentDidUpdate(prevProps, prevState) {
        // if (this.props.products_set === true  && this.props.minibasket_set === false && this.props.basket_lines !== prevProps.basket_lines) {            
        if (this.props.basket_products !== prevProps.basket_products && this.props.num_of_products === this.props.basket_products.length ) {
            // console.log(`basket products count `, this.props.basket_products);
            
        }
        if (this.props.products !== prevProps.products && this.props.products.length === 5) {
            // console.log(`passed on products`, this.props.products);
            this.query_products_detail();            
        }
               

        if (this.props.basketItems !== prevProps.basketItems) {
            
        }
                

        if (this.props.products_detail_temp !== prevProps.products_detail_temp  ){
            // console.log(`this.props.products_detail_temp.length `, this.props.products_detail_temp.length);
            // console.log(`Props 1: `, this.props)
            this.init_products_meta_details();
        }

        if (this.props.products_detail !== prevProps.products_detail && this.props.products_detail.length === 5 ){            
            this.query_products_extra();            
        }

        if (this.props.children_products !== prevProps.children_products && this.props.children_products.length === 2){
                
        }

        if (this.props.children_products_detail !== prevProps.children_products_detail && this.props.children_products_detail.length === 15 ){
            // console.log(`Getting Somewhere`, this.props);
            this.basket_items();
        }

        if (this.props.products_set === true && this.props.minibasket_set === false) {            
            
        }
    }

    set_minibasket = () => {
        this.setState({
            minibasket_set: true
        });

        // console.log(`new state`, this.state)
    }

    update_basket = () => {
        // console.log(`updating mini basket 2`,this.props.basket_lines);
        this.basket_items();
    }

    test = () => {
        // console.log(`new child works`, this.state)
    }
    basket_items = () => {
        // console.log(`Basket Items`);
        let products = [];
        let i=0;
        let product_title;
        let product_url;
        let comfort, size, product_category;   
        let basket_line, line__graphic__image, line__details, line__details__row, line__details__options, line__details__product_title, line__details__qty, line__details__price, line__details__price_strike, line__details__price_highlight;            
        
        const lines = this.props.basket_lines;        
        // console.log(`Cart Products`, lines)

            for (let [key, pvalue] of Object.entries(lines)) {       
                i = i +1;                      
                // console.log(`Cart Product`, pvalue)  
                fetchData( pvalue.product )

                .then( (data) => {                                    
                    // console.log(`Data: `, data);                    
                    // console.log(`Pvalue: `, pvalue);                    
                    product_title = data.title
                    product_url = this.props.get_product_url(product_title); 
                    // console.log(`Product Url`, product_url);
                    product_category = this.props.get_product_category(product_title);
                    // console.log(`Product Category`, product_category);

                    if (product_category === 'cocoon-classic') {
                        line__graphic__image = <img src= {ASSETS_URL + "/media/original_images/cocoon_classic.original.jpg"}
                        className="basket-line__graphic__image" alt={ product_title } />
                    }else if (product_category === 'cocoon-essential') {
                        line__graphic__image = <img src={ASSETS_URL + "/media/original_images/Cocoon-8IN-Shop-Section.png"}
                        className="basket-line__graphic__image" alt={ product_title } />
                    }else if (product_category === 'sealy-essential') {
                        line__graphic__image = <img src= {ASSETS_URL + "/media/original_images/essentials-pillow-optimized.png"}
                        className="basket-line__graphic__image" alt={ product_title } />
                    }else if (product_category === 'sealy-premium') {
                        line__graphic__image = <img src={ASSETS_URL + "/media/original_images/premium-pillow-optimized.png"}
                        className="basket-line__graphic__image" alt={ product_title } />
                    }else if (product_category === 'sealy-performance') {
                        line__graphic__image = <img src={ASSETS_URL + "/media/original_images/performance-pillow-optimized.png"}
                        className="basket-line__graphic__image" alt={ product_title } />
                    }

                    // console.log(`Line Image`, line__graphic__image);

                    if (pvalue.price_excl_tax_excl_discounts > pvalue.price_excl_tax){
                        line__details__price = <React.Fragment ><span className="basket-line__details__price--strike">${pvalue.price_excl_tax_excl_discounts}</span>
                                                <span className="basket-line__details__price--highlight">${pvalue.price_excl_tax}</span></React.Fragment>
                        // line__details__price = line__details__price_strike + line__details__price_highlight
                    }else{
                        line__details__price = <span>${pvalue.price_excl_tax}</span>
                    }

                    // // comfort = this.get_mattress_comfort(product_title);
                    // size = this.get_mattress_size( product_title );
                    // comfort = pvalue.attributes[1].value;
                    // size = pvalue.attributes[0].value;

                    // console.log(`Line Price`, line__details__price);

                    basket_line =   <div key={i} className="basket-line basket-line--minimal" >
                                        <div className="basket-line__graphic"><a href={ product_url }>{ line__graphic__image }</a></div>
                                        <div className="basket-line__details">
                                            <div className="basket-line__details__row">
                                                <div className="basket-line__details__product-title">
                                                    <h3><a href={product_url}>{ product_title }</a></h3>
                                                </div>
                                                <div className="basket-line__details__qty">
                                                    <p>{this.props.userlang ==='fr'? 'Qté' : 'Qty'}: {pvalue.quantity}</p>
                                                </div>
                                                <div className="basket-line__details__price">
                                                    {line__details__price}
                                                </div>
                                            </div>
                                            {/* <div className="basket-line__details__row">
                                                <div className="basket-line__details__options">
                                                    <ul>                                                            
                                                        <li>
                                                            Comfort: {comfort}, 
                                                            Size: {size}
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>                     

                    this.props.set_basketItems(basket_line);
                    
                });  
                // product_title = this.props.get_product_title(pvalue.product);    
                // product_url = this.props.get_product_url(product_title);       
                // // comfort = this.get_mattress_comfort(product_title);
                // // size = this.get_mattress_size( product_title );
                // comfort = pvalue.attributes[1].value;
                // size = pvalue.attributes[0].value;
                // product_category = this.props.get_product_category(product_title);
                
                // if (product_category === 'cocoon-classic') {
                //     line__graphic__image = <img src="https://assets-www.cocoonbysealy.ca/media/original_images/cocoon_classic.original.jpg"
                //     className="basket-line__graphic__image" alt={ product_title } />
                // }else{
                //     line__graphic__image = <img src="https://assets-www.cocoonbysealy.ca/media/original_images/Cocoon-8IN-Shop-Section.png"
                //     className="basket-line__graphic__image" alt={ product_title } />
                // }

                // if (pvalue.price_excl_tax_excl_discounts > pvalue.price_excl_tax){
                //     line__details__price = <React.Fragment ><span className="basket-line__details__price--strike">${pvalue.price_excl_tax_excl_discounts}</span>
                //                             <span className="basket-line__details__price--highlight">${pvalue.price_excl_tax}</span></React.Fragment>
                //     // line__details__price = line__details__price_strike + line__details__price_highlight
                // }else{
                //     line__details__price = <span>${pvalue.price_excl_tax}</span>
                // }
                // basket_line =   <div key={i} className="basket-line basket-line--minimal" >
                //                     <div className="basket-line__graphic"><a href={ product_url }>{ line__graphic__image }</a></div>
                //                     <div className="basket-line__details">
                //                         <div className="basket-line__details__row">
                //                             <div className="basket-line__details__product-title">
                //                                 <h3><a href={product_url}>{ product_title }</a></h3>
                //                             </div>
                //                             <div className="basket-line__details__qty">
                //                                 <p>{this.props.userlang ==='fr'? 'Qté' : 'Qty'}: {pvalue.quantity}</p>
                //                             </div>
                //                             <div className="basket-line__details__price">
                //                                 {line__details__price}
                //                             </div>
                //                         </div>
                //                         {/* <div className="basket-line__details__row">
                //                             <div className="basket-line__details__options">
                //                                 <ul>                                                            
                //                                     <li>
                //                                         Comfort: {comfort}, 
                //                                         Size: {size}
                //                                     </li>
                //                                 </ul>
                //                             </div>
                //                         </div> */}
                //                     </div>
                //                 </div>          
                // products = products.concat(basket_line);      
            }        
            if (this.props.basket_lines.length >= 0) 
                this.props.set_minibasket();
            // this.props.set_basketItems(products);                
            // console.log(`MiniBasket Products ${products}`)
            
            // return products;
                   
    }

    get_mattress_size = (data) => {
       // return this.props.match_mattress_size( data);
    //    console.log(`Rendering minibasket - get size`);
       let title;
        if (window.location.pathname === '/en/store/basket/' || window.location.pathname === '/fr/store/basket/') {
            title = window.Basket.get_product_title(data)
        }else  {
            // fetchData(data)
            // .then( (data) => {
            //     console.log(`mattress size working data test`, data);
            //     this.props.set_current_product_title(data.title);                
            // })
            // console.log(`mattress size working data`, this.props.current_product_title);
            title = data;
        }
        let mattress_size = "";        

        if (title.match(/King/g)) {
            // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
            mattress_size = "King";                    
        }else if (title.match(/Queen/g)) {
            // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
            mattress_size = "Queen";
        }else if (title.match(/Full/g)) {
            // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
            mattress_size = "Full";
        }else if (title.match(/Twin/g) && !title.match(/XL/g)) {
            // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
            mattress_size = "Twin";
        }else if (title.match(/XL/g) && title.match(/Twin/g)) {
            // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
            mattress_size = "Twin XL";
        }
        return mattress_size;
        
    }

    get_mattress_comfort = (title) => {
       // return this.props.match_mattress_comfort(data);
    //    console.log(`Rendering minibasket - get comfort`);
       let comfort = "";
        if (title.match(/Soft/g)) {
            // alert("FUCK YEAH Soft Title: " + childProducts.title + " ID" + childProducts.id);
            comfort = "Soft";
        }else if (title.match(/Firm/g)) {
            // alert("FUCK YEAH Firm Title: " + childProducts.title + " ID" + childProducts.id);
            comfort = "Firm";
        }else if (title.match(/Medium/g)) {
            // alert("FUCK YEAH Medium Title: " + childProducts.title + " ID" + childProducts.id);
            comfort = "Medium";
        }

        return comfort;
    }    

    get_child_products = () => {
        // this.props.get_child_products()
        // if (this.props.parent_products.length > 0) {
        //     console.log(`parent product cart`,this.props.parent_products)                                    
        // }               
                        
    }

    query_products = () => {
        getProducts()

        .then((data) => {                        
           this.props.init_products(data);
        })        
        // console.log(`Products`, products);
    } 

    query_products_detail = () => {        
        let i=0;
        let products_data = this.props.products;
        let product_detail = [];
        let result;        
        let product_attribute;
        let product_attributes = [];
        let item_category;

        // console.log(`Aquiring Products Details begins `, this.props);

        for (i=0; i < products_data.length; i++) {                
            // console.log(`Product Url: `, products_data[i].url);
            // console.log(`Product Title: `, products_data[i].title);
            fetchData( products_data[i].url )

            .then( (data) => {                
                this.props.init_products_details_temp(data);
                // console.log(`Data: `, data);
                // this.state.temp_products_detail.concat(data);
            });            

            if (products_data[i].title === "Essential Medium") {
                item_category = 'cocoon-essential';
            } else if (products_data[i].title === "Cocoon Classic") {
                item_category = 'cocoon-classic';
            } else if (products_data[i].title.match(/Sealy Premium/g) ) {
                item_category = 'sealy-premium';
            } else if (products_data[i].title.match(/Sealy Performance/g) ) {
                item_category = 'sealy-performance';
            } else if (products_data[i].title.match(/Sealy Essential/g) ) {
                item_category = 'sealy-essential';
            }  
                        
            product_attribute = {
                category: item_category,                
                parent_id: products_data[i].id 
            }

            product_attributes = product_attributes.concat(product_attribute);  
        }        
        
        this.props.init_product_meta(product_attributes);

        //     let data = this.state.child_products
        // let i=0;
        // for (i=0; i < data.length; i++) {
        //     // console.log(`Count .... ${i}`);
        //     this.getProductSku(data[i].sku_url, data[i].id, i);
        //     this.getProductPrice(data[i].price_url, data[i].id, i);
        //     this.getProductAvailabiliy(data[i].availability_url, data[i].id, i);
        // }
    }    

    init_products_meta_details = () => {
        // console.log(`temp products detail`, this.props.products_detail_temp);
        this.props.init_products_details(this.props.products_detail_temp);        
    }

    query_products_extra = () => {
        const products = this.props.products_detail;
        let default_products=[];
        let product_options=[];
        let default_product_item, options;
        let product_data;
        // console.log(`Products Detail`, products);
        let i=0;
        for (i=0; i < products.length; i++) {
            // console.log(`product count : ${i} `);
            if (products[i].structure === 'standalone') {
                // default_product_item = {id:products[i].id, parent: ''}                
                // this.props.set_default_products(default_product_item);
                // get product price, sku, and availability
                // this.get_product_price(products[i].id, products[i].price);
                // this.get_product_sku(products[i].id, products[i].stockrecords);
                // this.get_product_availability(products[i].id, products[i].availability)
            }else{
                // add child products
                // console.log(`Add child Products`, products[i].children);
                this.add_child_products(products[i].children, products[i].product_class, products[i].id);
                // console.log(`Product data`, product_data);
                // default_product_item = product_data.default_product_item;
                // options = product_data.options;
                // product_options = product_options.concat(options);                
            }
            

            // default_products = default_products.concat(default_product_item);            
        }        
        

        
        // this.props.set_product_options(product_options);
        // this.props.set_default_products(default_products);
    }

    add_child_products = (children, category, parent_id) => {
        let i=0;
        let size;
        let comfort;        
        let default_product;
        let default_product_item, item_category;
        let product_options=[];
        let data;
        let options;
        for (i=0; i < children.length; i++) {
            // children[i].title
            data = {id: category, product: children[i]}
            this.props.set_child_products(data);
            this.get_children_product_detail(children[i]);
            // if (category === "mattress") {
            //     // set product options
            //     size = this.props.match_mattress_size(children[i].title);
            //     comfort = this.props.match_mattress_comfort(children[i].title);
            //     // default_product = this.props.set_default_product(children[i].title);
            //     // if (default_product === true){
            //     //     default_product_item = {id:children[i].id, parent: parent_id}                    
            //     // }

            //     if (children[i].title.match(/Essential Medium/g)) {
            //         item_category = 'cocoon-essential';
            //     } else if (children[i].title.match(/Cocoon Classic/g)) {
            //         item_category = 'cocoon-classic';
            //     }

            //     options = {id: children[i].id, size: size, comfort: comfort, category: item_category};    
            //     product_options = product_options.concat(options);                                            
            //     store default product
            // }
        }
        
        // return {options:product_options};
    }
    

    get_product_meta_data = (category) => {
        const data=this.props.parent_products_meta_data;
        // console.log(`category ${category} data`, data);
        const attributes = data.filter(item => item.category === category);
        return attributes;
    }

    get_product_price = (id, url) => {
        
        fetchData(url).then( (response) => {             
            // console.log(`Response Price: `, response);    
            this.props.set_product_price(response, id);                        
        });
        
    }

    get_product_sku = (id, url) => {
        fetchData(url).then( (response) => {       
            // console.log(`Response SKU: `, response);
            this.props.set_product_sku(response[0].partner_sku, id);
        });        
    }

    get_product_availability = (id, url) => {
        fetchData(url).then( (response) => {        
            // console.log(`Response Availability: `, response);    
            this.props.set_product_availability(response, id);                        
        });     
    }

    get_children_product_detail = (products) => {        
        // console.log(`Add child Products Detail`, products);
                
        // console.log(`Products ULR: `, products.url);  
        fetchData(products.url).then( (response) => {
            // console.log(`Response Product: `, response);  
            this.props.set_child_products_detail(response);
            // this.get_product_price(response.id, response.price);
            // this.get_product_sku(response.id, response.stockrecords);
            // this.get_product_availability(response.id, response.availability);
        });
                
    }


    render(){         
        // const parent_products = this.get_child_products();    
        
        return(
                        
            <React.Fragment >
                {/* <Basketmenuitems
                    toggleBasketModal={this.toggleShow}
                    isShow={this.props.isShow}                    
                /> */}
                {/* <div className="ReactModalPortal" id="cocoon-basket"> */}
                    <div onClick={this.props.closeModal} className="ReactModal__Overlay ReactModal__Overlay--after-open"
                        style={this.props.modalStyle}>
                        <div style={this.props.divStyle}
                            className="ReactModal__Content ReactModal__Content--after-open basket-modal" tabIndex="-1" role="dialog"
                            aria-label="Your Cart">
                            <div className="pdp-modal__close basket-popover__close">
                            {svgCloseicon()}
                            </div>
                            <div className={this.props.cartModal}>                            
                                <h2 className="basket-popover__title">
                                    <a href="https://www.cocoonbysealy.com/store/basket/">
                                        <strong>{this.props.userlang ==='fr'? 'Votre panier': 'Your Cart'}</strong> 
                                        <span>({this.props.num_of_products} {this.props.userlang ==='fr'? 'articles': 'items'})</span>
                                    </a>
                                </h2>
                                <div className="basket-popover__lines">
                                    <div className="basket-lines__content">
                                        <div>
                                        
                                        {
                                        
                                        this.props.basketItems.map( (line, index) => (line))
                                        
                                        } 
                                            {/* <div className="basket-line basket-line--minimal">
                                                <div className="basket-line__graphic"><a
                                                        href="https://www.cocoonbysealy.com/mattress/chill-experience/"><img
                                                            src="https://assets-www.cocoonbysealy.com/media/images/products/2018/11/BundleImag2.jpg"
                                                            className="basket-line__graphic__image" /></a></div>
                                                <div className="basket-line__details">
                                                    <div className="basket-line__details__row">
                                                        <div className="basket-line__details__product-title">
                                                            <h3><a
                                                                    href="https://www.cocoonbysealy.com/mattress/chill-experience/v/47/">The
                                                                    Chill Experience, Queen</a></h3>
                                                        </div>
                                                        <div className="basket-line__details__qty">
                                                            <p>Qty: 1</p>
                                                        </div>
                                                        <div className="basket-line__details__price">$0.00</div>
                                                    </div>
                                                    <div className="basket-line__details__row">
                                                        <div className="basket-line__details__options">
                                                            <ul></ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="basket-popover__totals">
                                    <div className="basket-popover__total">
                                        <div className="basket-popover__total-column basket-popover__total-column--left">{this.props.userlang ==='fr'? 'Sous-total': 'Subtotal'}</div>
                                        <div className="basket-popover__total-column basket-popover__total-column--right">${this.props.basket.total_excl_tax}</div>
                                    </div><a href={cart_url} className="button button--inverse">{this.props.userlang ==='fr'? 'Voir le panier': 'View cart'}</a><a href={checkout_url} className="button"
                                        id="basket-summary__checkout--cart-tracking">{this.props.userlang ==='fr'? 'Payer': 'Checkout'}</a>                                               
                                </div>
                            </div>
                        </div>
                    </div>
                {/* </div> */}
                {/* <Middleware 
                    // num_of_items={this.num_of_products}
                    // openCloseBasketModal={this.openCloseBasketModal}
                /> */}
            </React.Fragment>
        )
    } 
}

function svgCloseicon (props) {
    return (
        <svg 
            version="1.1" 
            id="Layer_1" 
            xmlns="http://www.w3.org/2000/svg" 
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px" 
            y="0px" 
            viewBox="52.9 54.2 43 43.6" 
            enableBackground="new 52.9 54.2 43 43.6" 
            xmlSpace="preserve"
            className="pdp-modal__close-icon"
        >
            <g>
                <g>
                    <path fill="#999999" d="M54.3,97.4c-0.2,0-0.7,0-1-0.2c-0.5-0.5-0.5-1.2,0-1.8l40.5-40.5c0.5-0.5,1.2-0.5,1.8,0
            c0.5,0.5,0.5,1.2,0,1.8L55,97.1C54.8,97.4,54.5,97.4,54.3,97.4z"></path>
                </g>
            </g>
            <g>
                <g>
                    <path fill="#999999" d="M94.8,97.4c-0.2,0-0.8,0-1-0.2L53.2,56.6c-0.5-0.5-0.5-1.2,0-1.8c0.5-0.5,1.2-0.5,1.8,0l40.5,40.5
            c0.5,0.5,0.5,1.2,0,1.8C95.5,97.4,95,97.4,94.8,97.4z"></path>
                </g>
            </g>
        </svg>
    )
}


function getSizex() {
        
    const screenSize = window.document.documentElement.clientWidth;  
    const XscreenSize = window.document.documentElement.screenSize; 
    // console.log(`screenSize: ${XscreenSize} screenWidth: ${screenSize}`);
    if (screenSize > iPad && screenSize < iPadpro) {
        popoverWidth = 200
    }else if (screenSize > iPadpro && screenSize <= 1300) {
        popoverWidth = 300
    }else if (screenSize > 1300 && screenSize <= 1350) {
        popoverWidth = 325
    }else if (screenSize > 1350 && screenSize <= 1400) {
        popoverWidth = 350
    }else if (screenSize > 1400 && screenSize <= 1450) {
        popoverWidth = 375
    }else if (screenSize > 1450 && screenSize <= 1500) {
        popoverWidth = 400
    }else if (screenSize > 1500 && screenSize <= 1550) {
        popoverWidth = 425
    }else if (screenSize > 1550 && screenSize <= 1600) {
        popoverWidth = 450
    }else if (screenSize > 1650 && screenSize <= 1700) {
        popoverWidth = 475
    }else if (screenSize > 1750 && screenSize <= 1800) {
        popoverWidth = 500
    }else if (screenSize > 1850 && screenSize <= 1900) {
        popoverWidth = 525
    }else if (screenSize == iPad) {
        popoverWidth = 60
    }else if (screenSize == iPadpro) {
        popoverWidth = 160
    } else {
        popoverWidth = 669.5
    }
    // console.log(`cart position: ${popoverWidth} `);

    return (
        popoverWidth
    )
    
}



export default Cartbasketitems;